import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocations } from './useLocations';

const mapFormPropsToOption = form => ({
    value: form.id,
    label: form.internalName,
});

export const useFormsOptions = () => {
    const forms = useSelector(state => state.forms.data.forms);
    const isFormsLoaded = useSelector(state => state.forms.loaded);
    const { locationsMap } = useLocations();

    const getFormsOptionsByLocationId = useCallback(
        (locationId, propsMapper = mapFormPropsToOption) => {
            const location = locationsMap[locationId];
            if (!location) return [];

            return forms
                .filter(
                    form =>
                        form.locationId === location.companyId ||
                        (!form.locationId && form.brandId === location.brand?.id),
                )
                .map(propsMapper);
        },
        [forms, locationsMap],
    );

    const getFormsOptionsByBrandId = useCallback(
        (brandId, propsMapper = mapFormPropsToOption) => {
            if (!brandId) return [];

            return forms.filter(form => !form.locationId && form.brandId === brandId).map(propsMapper);
        },
        [forms],
    );

    return {
        getFormsOptionsByLocationId,
        getFormsOptionsByBrandId,
        isFormsLoaded,
    };
};
